import Manual from '../Pages/Manual/Manual';
import NotAuth from '../Pages/NotAuth';
import Pay from '../Pages/RevolutPay/Pay';
import PaymentSuccess from '../Pages/RevolutPay/PaymentSuccess';
import EachTicket from '../Pages/ServiceDesk/EachTicket';
import ServiceDesk from '../Pages/ServiceDesk/TicketsMainPage';
import SignIn from '../Pages/SignIn';
import Subscriptions from '../Pages/Subscriptions/Subscriptions';

export const ExternalRoutes = [

    {
        path: "/Login",
        name: "SignIn",
        component: SignIn,
        children: null
    },
    {
        path: "/notAuth",
        name: "NotAuth",
        component: NotAuth,
        children: null,
        closedMenu: false,
        subtab: ''
    }
];

const InternalPagesAdmin: any[] = [];
const InternalPagesRoutes: any[] = [];
export function InternalRoutes(isA: boolean, isAuth: boolean, isAllowedPayment: boolean) {

    InternalPagesAdmin.push(
        {
            path: "/Documentation",
            name: "Documentation",
            component: Manual,
            children: null,
            closedMenu: false,
            subtab: ''
        },
        {
            path: "/Subscriptions",
            name: "Subscriptions",
            component: Subscriptions,
            children: null,
            closedMenu: false,
            subtab: ''
        },
        {
            path: "/ServiceDesk",
            name: "ServiceDesk",
            component: ServiceDesk,
            children: null,
            closedMenu: false,
            subtab: ''
        },
        {
            path: "/ServiceDesk/Ticket",
            name: "EachTicket",
            component: EachTicket,
            children: null,
            closedMenu: false,
            subtab: ''
        }
    )
    if (isAllowedPayment) {
        InternalPagesAdmin.push({
            path: "/Pay",
            name: "Pay",
            component: Pay,
            children: null,
            closedMenu: false,
            subtab: ''
        },{
            path: "/success",
            name: "success",
            component: PaymentSuccess,
            children: null,
            closedMenu: false,
            subtab: ''
        });
    }

    InternalPagesRoutes.push(
        {
            path: "/Documentation",
            name: "Documentation",
            component: Manual,
            children: null,
            closedMenu: false,
            subtab: ''
        },
    )
    if (!isAuth) {
        return ExternalRoutes;
    }
    else {
        return isA ? InternalPagesAdmin : InternalPagesRoutes;
    }
};



